import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Client as Styletron } from "styletron-engine-monolithic";
import { Provider as StyletronProvider } from "styletron-react";
import { ToastContainer } from 'react-toastify';

import 'swiper/css';
import 'swiper/css/virtual';
import './styles/custom-styles.css';
import 'react-photo-view/dist/react-photo-view.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const engine = new Styletron();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <BrowserRouter>
        {/* <BaseProvider theme={LightTheme}> */}
          <StyletronProvider value={engine} debugAfterHydration>
            {/* <Container style={{minHeight: '100vh'}}> */}
              <ToastContainer 
                position="bottom-center"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="dark"
              />
              <App />
              {/* <Fab sx={fabStyle} onClick={() => {
                let outsideLink = document.createElement('a');
                outsideLink.target= '_blank';
                outsideLink.href= "https://api.whatsapp.com/send?phone=6282340243600";
                outsideLink.click();
              }}>
                <WhatsApp sx={{fontSize: 32}}/>
              </Fab> */}
            {/* </Container> */}
            {/* <Footer /> */}
          </StyletronProvider>
        {/* </BaseProvider> */}
      </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
